import script from "./warehousingTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./warehousingTwo.vue?vue&type=script&setup=true&lang=ts"

import "./warehousingTwo.vue?vue&type=style&index=0&id=769000b5&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769000b5"]])

export default __exports__